import { pipeLatLngs, haversine } from './model';
import { distToLines } from './dxf';

export const PLAN_TOLS = [0.5, 1, 2, 5];
const STEP = 0.5;

// sample each own (non-imported) pipe and compare with the CAD reference lines
export function planCheck(project, tol = project?.cad?.tol ?? 1) {
  const lines = (project?.cad?.ents || []).filter((e) => e.type === 'line').map((e) => e.pts);
  if (!lines.length) return [];
  return (project.pipes || []).filter((p) => !p.imported).map((p) => {
    const P = pipeLatLngs(p, project.fittings);
    let max = 0, devLen = 0, len = 0, run = null;
    const runs = [];
    for (let i = 0; i + 1 < P.length; i++) {
      const L = haversine(P[i], P[i + 1]), n = Math.max(1, Math.ceil(L / STEP));
      for (let k = i ? 1 : 0; k <= n; k++) {
        const q = [P[i][0] + ((P[i + 1][0] - P[i][0]) * k) / n, P[i][1] + ((P[i + 1][1] - P[i][1]) * k) / n];
        const d = distToLines(q, lines);
        max = Math.max(max, d);
        if (d > tol) { if (!run) runs.push((run = [])); run.push(q); if (run.length > 1) devLen += L / n; } else run = null;
      }
      len += L;
    }
    return { id: p.id, name: p.name || p.label || p.id, type: p.type, dn: p.dn, len, max, devLen, runs: runs.filter((r) => r.length > 1), ok: max <= tol, pts: P };
  }).filter((r) => r.len > 0);
}
